import styled from "styled-components";

export const Grid = styled.div<{ $count: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $count }) => $count}, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 24px;

  @media (max-width: 1439px) {
    grid-template-columns: repeat(${({ $count }) => ($count > 4 ? 3 : $count)}, minmax(0, 1fr));
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
  @media (max-width: 330px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #ece4da;
  border-radius: 14px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 96px;
  box-sizing: border-box;
  min-width: 0;

  @media (max-width: 480px) {
    padding: 14px;
    gap: 8px;
    min-height: 0;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #8a7f74;
`;

export const Label = styled.span`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  color: #6b6259;
`;

export const Value = styled.div`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 28px;
  font-weight: 800;
  color: #111111;
  line-height: 1;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

export const IconWrap = styled.span`
  display: inline-flex;
  color: #b0a599;
`;
